// extracted by mini-css-extract-plugin
export var chip = "_mb-2";
export var chipBody = "_mb-8";
export var chipHeader = "_mb-9";
export var chipWithKind = "_mb-7";
export var icon = "_mb-3";
export var kind = "_mb-a";
export var remove = "_mb-5";
export var removeIcon = "_mb-6";
export var row = "_mb-0";
export var rowHistorical = "_mb-1";
export var text = "_mb-4";